import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Aos from "aos";
import "aos/dist/aos.css";

import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import { motion } from "framer-motion";

// project imports
import AppBar from "@stories/ui-component/extended/AppBar";
import HeaderSection from "./HeaderSection";
import FeatureSection from "./FeatureSection";
// import FooterSection from "./FooterSection";
// import CustomizeSection from "./CustomizeSection";
import StartupProjectSection from "./StartupProjectSection";
import { ContactForm } from "@stories/molecules/ContactForm/ContactForm";
import leadingSocials from "assets/images/home/leading-socials.webp";
import sliderlogo1 from "assets/images/home/slider-logo-1.webp";
import FooterLogo from "assets/images/home/footer-logo-new.webp";
import sliderImg1 from "assets/images/home/leading-socials.webp";
import ManageReview from "assets/images/home/Coordinate3-min.png";
import Monitor from "assets/images/home/Monitor4-min.png";
import Report from "assets/images/home/2-min.png";
import Search from "assets/images/home/Smart Directory6-min.png";
import Platform from "assets/images/home/9-min.png";
import HeroBg from "assets/images/home/1.png";
import ImgTop1 from "assets/images/home/2b.png";
import ImgTop2 from "assets/images/home/2.png";
import APIIntegrations from "assets/images/home/API Integrations7-min.png";
import Directory from "assets/images/home/Directory8-min.png";
import Logo from "assets/images/home/SocialPro_Blue.png";
import CTAbg from "assets/images/home/cta-bg.webp";
import instgram from "assets/images/icons/instgram-logo.webp";
import linkedin from "assets/images/icons/linkedin-logo.webp";
import "./style.css";

// =============================|| LANDING MAIN ||============================= //

export const Home = () => {
  const [featureTabs, setfeatureTabs] = useState("coordinates");
  const [IsSticky, setIsSticky] = useState(false);
  const [IsActive, setIsActive] = useState(false);
  const [IsMenuActive, setIsMenuActive] = useState(false);

  const handleMenu = () => {
    setIsMenuActive(!IsMenuActive);
  };

  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    autoplay: false,
    autoplaySpeed: 7000,
    cssEase: "linear",
  };

  const settingsAnimation = {
    className: "center",
    dots: false,
    arrows: false,
    centerPadding: "0",
    centerMode: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    vertical: true,
    verticalSwiping: true,
    focusOnSelect: true,
    autoplay: true,
    autoplaySpeed: 3000,
  };

  const settingsLogoslider = {
    dots: false,
    arrows: false,
    autoplay: true,
    autoplaySpeed: 2000,
    infinite: true,
    slidesToShow: 5,
    slidesToScroll: 1,
    cssEase: "linear",
    responsive: [
      {
        breakpoint: 1100,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 900,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 2,
        },
      },
      {
        breakpoint: 640,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 374,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
    ],
  };

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const handleScroll = () => {
    if (window.scrollY > 50) {
      setIsSticky(true);
    } else {
      setIsSticky(false);
    }
  };

  useEffect(() => {
    document.body.scrollTop = 0; // For Safari
    document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
  }, []);

  useEffect(() => {
    Aos.init({ duration: 1000 });
  }, []);

  return (
    <>
      {/* Hero Section  */}

      <header className={IsSticky ? "header-sticky" : "header-default"}>
        <div className="container-new">
          <div className="navigation">
            <a href="/" className="site-logo">
              <img src={Logo} alt="socialpro" />
            </a>
            <ul>
              <li>
                <a href="/">Features</a>
                <ul className="dropdown-content">
                  <li>
                    <a href="#coordinates" onClick={() => setfeatureTabs("coordinates")}>
                      Co-ordinate
                    </a>
                  </li>
                  <li>
                    <a href="#monitor" onClick={() => setfeatureTabs("monitor")}>
                      Monitor
                    </a>
                  </li>

                  <li>
                    <a href="#report" onClick={() => setfeatureTabs("report")}>
                      Report
                    </a>
                  </li>
                  <li>
                    <a href="#search" onClick={() => setfeatureTabs("search")}>
                      Smart Directory
                    </a>
                  </li>
                  <li>
                    <a href="#apiInteg">API Integration</a>
                  </li>
                </ul>
              </li>
              <li>
                <Link to="/request-demo">Request a Demo</Link>
              </li>
              <li>
                <a href="/login" className="nav-login">
                  <svg
                    data-bbox="0 0 50 50"
                    data-type="shape"
                    xmlns="http://www.w3.org/2000/svg"
                    width="35"
                    height="35"
                    viewBox="0 0 50 50"
                    fill="#0099fa"
                  >
                    <g>
                      <path d="M25 48.077c-5.924 0-11.31-2.252-15.396-5.921 2.254-5.362 7.492-8.267 15.373-8.267 7.889 0 13.139 3.044 15.408 8.418-4.084 3.659-9.471 5.77-15.385 5.77m.278-35.3c4.927 0 8.611 3.812 8.611 8.878 0 5.21-3.875 9.456-8.611 9.456s-8.611-4.246-8.611-9.456c0-5.066 3.684-8.878 8.611-8.878M25 0C11.193 0 0 11.193 0 25c0 .915.056 1.816.152 2.705.032.295.091.581.133.873.085.589.173 1.176.298 1.751.073.338.169.665.256.997.135.515.273 1.027.439 1.529.114.342.243.675.37 1.01.18.476.369.945.577 1.406.149.331.308.657.472.98.225.446.463.883.714 1.313.182.312.365.619.56.922.272.423.56.832.856 1.237.207.284.41.568.629.841.325.408.671.796 1.02 1.182.22.244.432.494.662.728.405.415.833.801 1.265 1.186.173.154.329.325.507.475l.004-.011A24.886 24.886 0 0 0 25 50a24.881 24.881 0 0 0 16.069-5.861.126.126 0 0 1 .003.01c.172-.144.324-.309.49-.458.442-.392.88-.787 1.293-1.209.228-.232.437-.479.655-.72.352-.389.701-.78 1.028-1.191.218-.272.421-.556.627-.838.297-.405.587-.816.859-1.24a26.104 26.104 0 0 0 1.748-3.216c.208-.461.398-.93.579-1.406.127-.336.256-.669.369-1.012.167-.502.305-1.014.44-1.53.087-.332.183-.659.256-.996.126-.576.214-1.164.299-1.754.042-.292.101-.577.133-.872.095-.89.152-1.791.152-2.707C50 11.193 38.807 0 25 0"></path>
                    </g>
                  </svg>
                  <span>Login</span>
                </a>
              </li>
            </ul>

            {IsActive === false ? (
              <button type="button" className="hamburger-menu" onClick={() => setIsActive(!IsActive)}>
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="#0099fa" height={32}>
                  <path
                    fillRule="evenodd"
                    d="M3 6.75A.75.75 0 013.75 6h16.5a.75.75 0 010 1.5H3.75A.75.75 0 013 6.75zM3 12a.75.75 0 01.75-.75h16.5a.75.75 0 010 1.5H3.75A.75.75 0 013 12zm0 5.25a.75.75 0 01.75-.75h16.5a.75.75 0 010 1.5H3.75a.75.75 0 01-.75-.75z"
                    clipRule="evenodd"
                  />
                </svg>
              </button>
            ) : (
              <button type="button" className="hamburger-menu" onClick={() => setIsActive(!IsActive)}>
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="#0099fa" height={32}>
                  <path
                    fillRule="evenodd"
                    d="M5.47 5.47a.75.75 0 011.06 0L12 10.94l5.47-5.47a.75.75 0 111.06 1.06L13.06 12l5.47 5.47a.75.75 0 11-1.06 1.06L12 13.06l-5.47 5.47a.75.75 0 01-1.06-1.06L10.94 12 5.47 6.53a.75.75 0 010-1.06z"
                    clipRule="evenodd"
                  />
                </svg>
              </button>
            )}
          </div>
        </div>
        {/* Mob Navigation  */}
        {IsActive && (
          <div className="container-new">
            <div className="mob-nav">
              <ul>
                <li>
                  <button
                    onClick={handleMenu}
                    className={IsMenuActive === true ? "dropdown-link svg-rotate" : "dropdown-link"}
                  >
                    Features
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 24 24"
                      strokeWidth={1.5}
                      stroke="#0099fa"
                      fill="none"
                      height={19}
                    >
                      <path strokeLinecap="round" strokeLinejoin="round" d="M19.5 8.25l-7.5 7.5-7.5-7.5" />
                    </svg>
                  </button>
                  <ul
                    className={IsMenuActive === true ? "mob-nav-dropdown mob-nav-dropdown-active" : "mob-nav-dropdown"}
                  >
                    <li>
                      <a
                        href="#coordinates"
                        onClick={() => {
                          setfeatureTabs("coordinates");
                          setIsActive(!IsActive);
                          setIsMenuActive(!IsMenuActive);
                        }}
                      >
                        Co-ordinate
                      </a>
                    </li>
                    <li>
                      <a
                        href="#monitor"
                        onClick={() => {
                          setfeatureTabs("monitor");
                          setIsActive(!IsActive);
                          setIsMenuActive(!IsMenuActive);
                        }}
                      >
                        Monitor
                      </a>
                    </li>

                    <li>
                      <a
                        href="#report"
                        onClick={() => {
                          setfeatureTabs("report");
                          setIsActive(!IsActive);
                          setIsMenuActive(!IsMenuActive);
                        }}
                      >
                        Report
                      </a>
                    </li>
                    <li>
                      <a
                        href="#search"
                        onClick={() => {
                          setfeatureTabs("search");
                          setIsActive(!IsActive);
                          setIsMenuActive(!IsMenuActive);
                        }}
                      >
                        Smart Directory
                      </a>
                    </li>
                    <li>
                      <a
                        href="#apiInteg"
                        onClick={() => {
                          setIsActive(!IsActive);
                          setIsMenuActive(!IsMenuActive);
                        }}
                      >
                        API Integration
                      </a>
                    </li>
                  </ul>
                </li>
                <li>
                  <a href="">Request a Demo</a>
                </li>
                <li>
                  <a href="/login" className="nav-login">
                    <svg
                      data-bbox="0 0 50 50"
                      data-type="shape"
                      xmlns="http://www.w3.org/2000/svg"
                      width="35"
                      height="35"
                      viewBox="0 0 50 50"
                      fill="#0099fa"
                    >
                      <g>
                        <path d="M25 48.077c-5.924 0-11.31-2.252-15.396-5.921 2.254-5.362 7.492-8.267 15.373-8.267 7.889 0 13.139 3.044 15.408 8.418-4.084 3.659-9.471 5.77-15.385 5.77m.278-35.3c4.927 0 8.611 3.812 8.611 8.878 0 5.21-3.875 9.456-8.611 9.456s-8.611-4.246-8.611-9.456c0-5.066 3.684-8.878 8.611-8.878M25 0C11.193 0 0 11.193 0 25c0 .915.056 1.816.152 2.705.032.295.091.581.133.873.085.589.173 1.176.298 1.751.073.338.169.665.256.997.135.515.273 1.027.439 1.529.114.342.243.675.37 1.01.18.476.369.945.577 1.406.149.331.308.657.472.98.225.446.463.883.714 1.313.182.312.365.619.56.922.272.423.56.832.856 1.237.207.284.41.568.629.841.325.408.671.796 1.02 1.182.22.244.432.494.662.728.405.415.833.801 1.265 1.186.173.154.329.325.507.475l.004-.011A24.886 24.886 0 0 0 25 50a24.881 24.881 0 0 0 16.069-5.861.126.126 0 0 1 .003.01c.172-.144.324-.309.49-.458.442-.392.88-.787 1.293-1.209.228-.232.437-.479.655-.72.352-.389.701-.78 1.028-1.191.218-.272.421-.556.627-.838.297-.405.587-.816.859-1.24a26.104 26.104 0 0 0 1.748-3.216c.208-.461.398-.93.579-1.406.127-.336.256-.669.369-1.012.167-.502.305-1.014.44-1.53.087-.332.183-.659.256-.996.126-.576.214-1.164.299-1.754.042-.292.101-.577.133-.872.095-.89.152-1.791.152-2.707C50 11.193 38.807 0 25 0"></path>
                      </g>
                    </svg>
                    <span>Login</span>
                  </a>
                </li>
              </ul>
            </div>
          </div>
        )}
      </header>

      {/* Hero Section  */}
      <main className="hero-new">
        <div className="container-new">
          <div className="hero-main">
            <div className="hero-content" data-aos="fade-right" data-aos-duration="2000">
              <motion.div
                initial={{ opacity: 0, translateY: 550 }}
                animate={{ opacity: 1, translateY: 0 }}
                transition={{ type: "spring", stiffness: 150, damping: 30 }}
              >
                <h1>
                  Leading the way in <span> Social Procurement </span>
                </h1>
              </motion.div>
              <motion.div
                initial={{ opacity: 0, translateY: 550 }}
                animate={{ opacity: 1, translateY: 0 }}
                transition={{
                  type: "spring",
                  stiffness: 150,
                  damping: 30,
                  delay: 0.2,
                }}
              >
                <p>
                  SocialPro is a powerful cloud procurement software for reporting and monitoring social procurement
                  spend and performance. Take control of your project.
                </p>
              </motion.div>
              <div className="hero-btns">
                <motion.div
                  initial={{ opacity: 0, translateY: 550 }}
                  animate={{ opacity: 1, translateY: 0 }}
                  transition={{
                    type: "spring",
                    stiffness: 150,
                    damping: 30,
                    delay: 0.4,
                  }}
                >
                  <a href="/" className="discover">
                    Request a demo
                  </a>
                  <a href="/" className="request">
                    Contact sales
                  </a>
                </motion.div>
              </div>
            </div>
            <div className="hero-img">
              <img src={HeroBg} alt="HeroBg" />
              <div className="widget-1">
                <motion.div
                  initial={{ opacity: 0, scale: 0 }}
                  animate={{ opacity: 1, scale: 1 }}
                  transition={{
                    type: "spring",
                    stiffness: 150,
                    damping: 30,
                    delay: 0.2,
                  }}
                >
                  <img src={ImgTop1} alt="HeroBg" />
                </motion.div>
              </div>
              <div className="widget-2">
                <motion.div
                  initial={{ opacity: 0, scale: 0 }}
                  animate={{ opacity: 1, scale: 1 }}
                  transition={{
                    type: "spring",
                    stiffness: 150,
                    damping: 30,
                    delay: 0.2,
                  }}
                >
                  <img src={ImgTop2} alt="HeroBg" />
                </motion.div>
              </div>
            </div>
          </div>
        </div>
      </main>

      {/* Logo Slider  */}
      <div className="container-new slider-logo">
        <div>
          <Slider {...settingsLogoslider}>
            <div>
              <img src={sliderlogo1} alt="sliderlogo1" />
            </div>
            <div>
              <img src={sliderlogo1} alt="sliderlogo1" />
            </div>
            <div>
              <img src={sliderlogo1} alt="sliderlogo1" />
            </div>
            <div>
              <img src={sliderlogo1} alt="sliderlogo1" />
            </div>
            <div>
              <img src={sliderlogo1} alt="sliderlogo1" />
            </div>
            <div>
              <img src={sliderlogo1} alt="sliderlogo1" />
            </div>
          </Slider>
        </div>
      </div>

      {/* About Section  */}
      <div
        className="about-new"
        style={{ background: "linear-gradient(90deg, rgba(0,100,196,1) 0%, rgba(0,170,255,1) 100%)" }}
      >
        <div className="container-new">
          <div className="about-new-section">
            <h4 className="about-title">WHY SOCIALPRO?</h4>
            <h3 className="about-tagline">Improve data accuracy & completeness.</h3>
            <p className="about-sec-txt">
              Co-ordinate, monitor and report on social procurement performance from one place.
            </p>
            <div className="about-cards-section" data-aos="fade-up" data-aos-duration="2000">
              <div className="about-card">
                <h3>Powerful Platform</h3>
                <p>
                  Streamline the data collection process, with automated consolidation of project reporting. Analytics
                  provide oversight on performance and shortfalls.
                </p>
                <img src={Platform} alt="Platform" />
              </div>
              <div className="about-card">
                <h3>Smart Directory</h3>
                <p>
                  Connect with local suppliers who are best suited to enhancing your project's impact and supporting
                  your Company in meeting social procurement commitments.
                </p>
                <img src={Directory} alt="Directory" />
              </div>
              <div className="about-card">
                <h3>API Integration</h3>
                <p>
                  Easily monitor and manage your progress towards social spend and hours targets, with functionalities
                  to integrate with your existing platforms for a seamless experience.
                </p>
                <img src={APIIntegrations} alt="APIIntegrations" />
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Features Section  */}

      <div style={{ background: "linear-gradient(55deg, rgba(255,255,255,1) 1%, rgba(165,218,255,1) 100%)" }}>
        <div className="container-new feature-tab-section">
          <h4 className="feature-title">KEY FEATURES</h4>
          <h3 className="feature-tagline">Powerful solutions engineered for social procurement.</h3>
          <p className="feature-txt-new">
            Whether you're a global developer looking to improve transparency, or a forward-thinking contractor or
            subcontractor that's ready to organise your spend, SocialPro's leading technology can help you get there.
          </p>
          <div className="featrure-tabs-buttons">
            <button
              onClick={() => setfeatureTabs("coordinates")}
              className={featureTabs === "coordinates" ? "active-tab" : ""}
            >
              Co-ordinate
            </button>
            <button onClick={() => setfeatureTabs("monitor")} className={featureTabs === "monitor" ? "active-tab" : ""}>
              Monitor
            </button>
            <button onClick={() => setfeatureTabs("report")} className={featureTabs === "report" ? "active-tab" : ""}>
              Report
            </button>
            <button onClick={() => setfeatureTabs("search")} className={featureTabs === "search" ? "active-tab" : ""}>
              Search
            </button>
          </div>

          <div
            data-aos="fade-right"
            data-aos-duration="2000"
            className="inner-feature-container"
            style={{
              background: "linear-gradient(90deg, rgba(241,252,255,1) 60%, rgba(136,203,252,1) 100%)",
              overflow: "hidden",
            }}
          >
            <div className="feature-inner-wrapper">
              {/* Co-oridnate  */}
              {featureTabs === "coordinates" && (
                <div className="cooridnate-social" id="coordinates">
                  <div className="cooridnate-social-content">
                    <h4>CO-ORDINATE</h4>   
                    <h3>Streamlined data collection</h3>
                    <ul>
                      <li>Easy setup and seamless implementation.</li>
                      <li>Track reporting from subcontractors.</li>
                      <li>Automated input data collection with document upload.</li>
                    </ul>
                    <a href="/" className="discover">
                      Discover more
                    </a>
                    <a href="/" className="request">
                      Request a demo
                    </a>
                  </div>
                  <div className="cooridnate-img">
                    <img src={ManageReview} alt="ManageReview" />
                  </div>
                </div>
              )}
              {/* Monitor  */}
              {featureTabs === "monitor" && (
                <div className="cooridnate-social" id="monitor">
                  <div className="cooridnate-social-content">
                    <h4>MONITOR</h4>
                    <h3>Manage & review in <br />one place</h3>
                    <ul>
                      <li>Cloud-based platform accessible from any device.</li>
                      <li>Project-level analytics on performance against targets.</li>
                      <li>Connections to certified suppliers across various social targets.</li>
                    </ul>
                    <a href="/" className="discover">
                      Discover more
                    </a>
                    <a href="/" className="request">
                      Request a demo
                    </a>
                  </div>
                  <div className="cooridnate-img">
                    <img src={Monitor} alt="Monitor" />
                  </div>
                </div>
              )}
              {/* REPORT  */}
              {featureTabs === "report" && (
                <div className="cooridnate-social" id="report">
                  <div className="cooridnate-social-content">
                    <h4>REPORT</h4>
                    <h3>Improve accuracy and transparency</h3>
                    <ul>
                      <li>User-friendly dashboard.</li>
                      <li>Bespoke commentary on highlights and challenges.</li>
                      <li>Analytics designed for concise communication with stakeholders.</li>
                    </ul>
                    <a href="/" className="discover">
                      Discover more
                    </a>
                    <a href="/" className="request">
                      Request a demo
                    </a>
                  </div>
                  <div className="cooridnate-img">
                    <img src={Report} alt="Report" />
                  </div>
                </div>
              )}
              {/* SEARCH  */}
              {featureTabs === "search" && (
                <div className="cooridnate-social" id="search">
                  <div className="cooridnate-social-content">
                    <h4>SEARCH </h4>
                    <h3>Smart directory of verified social enterprises</h3>
                    <ul>
                      <li>Use AI to recommend suppliers to help support shortfalls.</li>
                      <li>Simply search by business name, impact category and location.</li>
                      <li>Identify best-fit products and services where there is local capacity.</li>
                    </ul>
                    <a href="/" className="discover">
                      Discover more
                    </a>
                    <a href="/" className="request">
                      Request a demo
                    </a>
                  </div>
                  <div className="cooridnate-img">
                    <img src={Search} alt="Search" />
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>

      {/* CTA Section API */}
      <div id="apiInteg">
        <div
          className="cta-wrapper"
          style={{ background: "linear-gradient(90deg, rgba(0,100,196,1) 0%, rgba(0,170,255,1) 100%)" }}
        >
          <div className="cta-new-section">
            <h4>API INTEGRATION</h4>
            <h3 data-aos="fade-in" data-aos-duration="1000" data-aos-easing="linear">
              We work the way you do.
            </h3>
            <p>Connect your existing construction & payment platforms, so your systems speak to each other.</p>
            <a href="/">Request a demo</a>
          </div>
          <img src={CTAbg} alt="CTAbg" className="cta-bg" />
        </div>
      </div>

      {/* Definitions Section  */}
      {/* <div style={{ background: "linear-gradient(55deg, rgba(255,255,255,1) 1%, rgba(165,218,255,1) 100%)" }}>
        <div className="definitions-section">
          <h3>Definitions</h3>
          <div>
            <p className="def-txt">
              At SocialPro, we value the privacy of our users. This document outlines the types of information we
              collect and how we use it.
            </p>
            <p className="def-txt">
              If you have any questions or need additional information, please don't hesitate to contact us.
            </p>
            <p className="def-txt">
              This privacy policy applies only to our online activities and is applicable to information shared and/or
              collected on our website. It does not apply to information collected offline or through channels other
              than our website.
            </p>
            <p className="def-txt">By using our website, you consent to our privacy policy and agree to its terms.</p>
            <p className="def-txt">
              <span>Information We Collect</span>
              We collect personal information to provide you with a better experience when using our website. We will
              clearly state the reason for collecting your personal information at the time it is requested.
            </p>
            <p className="def-txt">
              If you contact us directly, we may collect additional information about you, such as your name, email
              address, phone number, and any other information you choose to provide.
            </p>
            <p className="def-txt">
              When you register for an account, we may ask for your contact information, including your name, company
              name, address, email address, and phone number.
            </p>
          </div>
        </div>
      </div> */}

      {/* new form Section  */}

      <div
        className="forms-section"
        style={{ background: "linear-gradient(55deg, rgba(255,255,255,1) 1%, rgba(165,218,255,1) 100%)" }}
      >
        <div className="container-new">
          <div className="col-left">
            <h4 className="feature-title">LET'S TALK</h4>
            <h3>Contact us to learn more about add:</h3>
            <ul>
              <li>Requesting a Demo</li>
              <li>Plans & Pricing</li>
              <li>Product Capabilities</li>
              <li>Training & Support Services</li>
              <li>Business Solutions</li>
              <li>Software Integrations</li>
            </ul>
          </div>
          <div className="col-right">
            <div className="contact-form-new">
              <ContactForm />
            </div>
          </div>
        </div>
      </div>
      {/* CTA Section Leading */}
      {/* <div
        className="cta-wrapper"
        style={{
          background: "linear-gradient(90deg, rgba(0,100,196,1) 0%, rgba(0,170,255,1) 100%)",
        }}
      >
        <div className="cta-new-section">
          <h4>LEADING THE WAY</h4>
          <h3 data-aos="fade-in" data-aos-duration="1000" data-aos-easing="linear">
            Ready to take control of your project?
          </h3>
          <p>Get started with SocialPro.</p>
          <a href="/">Request a demo</a>
        </div>
        <img src={CTAbg} alt="CTAbg" className="cta-bg" />
      </div> */}

      {/* Leading Socials Section  */}
      {/* <div
        style={{
          background: "linear-gradient(55deg, rgba(255,255,255,1) 1%, rgba(165,218,255,1) 100%)",
          overflow: "hidden",
        }}
      >
        <div className="leading-social" >
          <div className="leading-social-content">
            <h3>Leading the way in Social Procurement</h3>
            <p>
              SocialPro is a powerful cloud procurement software for reporting and monitoring social procurement spend
              and performance. Take control of your project.
            </p>
            <a href="/">Request a demo</a>
          </div>
          <div className="leading-img" data-aos="fade-left"
        data-aos-duration="1500" data-aos-easing="linear">
            <img src={leadingSocials} alt="leadingSocials" />
          </div>
        </div>
      </div> */}

      {/* request a Demo Section  */}
      {/* <div
        style={{ background: "linear-gradient(90deg, rgba(0,100,196,1) 0%, rgba(0,170,255,1) 100%)" }}
      >
        <div className="container-new request-demo-section">
          <h3>Request a demo</h3>
          <p>
            Discover for yourself how SocialPro can transform social procurement for your organisation. Contact us to
            arrange a demo, and experience firsthand the seamless user interface and unparalleled capability of the
            platform, empowering you to streamline process and ultimately, be a driving force for social impact.
          </p>
        </div>
      </div> */}

      {/* Contact Section  */}
      {/* <div style={{ background: "linear-gradient(55deg, rgba(255,255,255,1) 1%, rgba(165,218,255,1) 100%)" }} id="contact">
        <div className="container-new contact-section">
          <div className="contact-form-new">
            <h4>Get in Touch</h4>
            <ContactForm />
          </div>
          <div className="contact-slider" data-aos="fade-left" data-aos-duration="3000">
            <Slider {...settings}>
              <div>
                <div className="contact-slider-img" >
                  <img src={sliderImg1} alt="sliderImg" />
                </div>
                <div className="contact-slider-content">
                  <h4>CO-ORDINATE</h4>
                  <h3>Manage & review in one place</h3>
                  <div className="slider-content-list">
                    <ul>
                      <li>Easy setup and seamless implementation.</li>
                      <li>Track reporting from subcontractors.</li>
                      <li>Automated input data collection with document upload.</li>
                    </ul>
                  </div>
                 
                </div>
              </div>
              <div>
                <div className="contact-slider-img">
                  <img src={sliderImg1} alt="sliderImg" />
                </div>
                <div className="contact-slider-content">
                  <h4>MONITOR</h4>
                  <h3>Assess & Certify</h3>
                  <div className="slider-content-list">
                    <ul>
                      <li>Cloud-based platform accessible from any device.</li>
                      <li>Project-level analytics on performance against targets.</li>
                      <li>Connections to certified suppliers across various social targets.</li>
                    </ul>
                  </div>
                 
                </div>
              </div>
              <div>
                <div className="contact-slider-img">
                  <img src={sliderImg1} alt="sliderImg" />
                </div>
                <div className="contact-slider-content">
                  <h4>REPORT</h4>
                  <h3>Manage & review in one place</h3>
                  <div className="slider-content-list">
                    <ul>
                      <li>User-friendly dashboard.</li>
                      <li>Bespoke commentary on highlights and challenges.</li>
                      <li>Analytics designed for concise communication with stakeholders.</li>
                    </ul>
                  </div>
                  
                </div>
              </div>
              <div>
                <div className="contact-slider-img">
                  <img src={sliderImg1} alt="sliderImg" />
                </div>
                <div className="contact-slider-content">
                  <h4>SEARCH </h4>
                  <h3>Smart Directory</h3>
                  <div className="slider-content-list">
                    <ul>
                      <li>Database of verified businesses, across multiple impact categories</li>
                      <li>Use AI to recommend suppliers to help support shortfalls.</li>
                      <li>Simply search by business name, impact category and location.</li>
                      <li>Identify best-fit products and services where there is local capacity.</li>
                    </ul>
                  </div>
                 
                </div>
              </div>
            </Slider>
          </div>
        </div>
      </div> */}

      {/* 6. Animation section */}
      <div className="animate-section">
        <div className="container-new">
          <div className="choose-socialpro">
            <h2 data-aos="fade-down" data-aos-duration="1000" data-aos-easing="linear">
              Choose SocialPro for
            </h2>
          </div>
          <div className="animated-heading">
            <Slider {...settingsAnimation}>
              <h5>Simplified Reporting</h5>
              <h5>Search</h5>
              <h5>Powerful Platform</h5>
              <h5>Project Transparency</h5>
              <h5>Integrate</h5>
            </Slider>
          </div>
        </div>
      </div>

      {/* Footer Section  */}
      <div style={{ background: "linear-gradient(90deg, rgba(0,100,196,1) 0%, rgba(0,170,255,1) 100%)" }}>
        <div className="container-new footer-flex">
          <div className="footer-links">
            <a href="/" className="footer-logo-new">
              <img src={FooterLogo} alt="FooterLogo" />
            </a>
            <div className="footer-social">
              <ul className="social-links">
                <li>
                  <a href="https://www.instagram.com/socialpro.app/" target="_blank">
                    <img src={instgram} alt="instgram" />
                  </a>
                </li>
                <li>
                  <a href="https://www.linkedin.com/company/socialpro-app/" target="_blank">
                    <img src={linkedin} alt="linkedin" />
                  </a>
                </li>
              </ul>
              <p>
                <span> SOCIALPRO™</span> (2023)
              </p>
            </div>
          </div>
          <div className="footer-links">
            <h4>Service</h4>
            <ul>
              <li>
                <a href="/">Request a demo</a>
              </li>
              <li>
                <a href="/">Start a project</a>
              </li>
              <li>
                <a href="/">Partnerships</a>
              </li>
              <li>
                <a href="/">API integration</a>
              </li>
            </ul>
          </div>
          <div className="footer-links">
            <h4>FEATURES</h4>
            <ul>
              <li>
                <a href="/">Mentor</a>
              </li>
              <li>
                <a href="/">Approve</a>
              </li>
              <li>
                <a href="/">Report</a>
              </li>
              <li>
                <a href="/">Smart Directory</a>
              </li>
            </ul>
          </div>
          <div className="footer-links">
            <h4>ABOUT</h4>
            <ul>
              <li>
                <a href="/">Contact us</a>
              </li>
              <li>
                <a href="/">Definitions</a>
              </li>
              <li>
                <a href="/">Privacy Policy</a>
              </li>
              <li>
                <a href="/">Terms & Conditions</a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </>
  );
};
